var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14107_16199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5831 6.75009L10.8331 1.50009M5.64689 6.91412L6.96095 10.2931C7.07671 10.5908 7.13459 10.7396 7.21799 10.7831C7.29029 10.8208 7.37642 10.8208 7.44876 10.7832C7.53222 10.7399 7.59027 10.5911 7.70638 10.2936L11.0016 1.84969C11.1064 1.5811 11.1588 1.4468 11.1301 1.36099C11.1052 1.28646 11.0467 1.22798 10.9722 1.20308C10.8864 1.17441 10.7521 1.22682 10.4835 1.33164L2.03963 4.62681C1.7421 4.74292 1.59333 4.80098 1.54997 4.88443C1.51239 4.95677 1.51244 5.0429 1.55011 5.1152C1.59356 5.1986 1.7424 5.25648 2.04007 5.37224L5.41907 6.6863C5.4795 6.70979 5.50971 6.72154 5.53515 6.73969C5.5577 6.75577 5.57742 6.77549 5.5935 6.79804C5.61165 6.82348 5.6234 6.85369 5.64689 6.91412Z",
    stroke: "#00A87C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14107_16199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.333344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.4319a54afb352b7da7faa83774ac2261.svg";
export { ForwardRef as ReactComponent };